import { SuiLogo } from "based-assets";
import { defineChain } from "viem";
import { IChain, ChainSymbols, ChainIds } from "./types";
import { networkSui } from "../networks";

export const chainSui: IChain = defineChain({
  id: ChainIds.sui,
  symbol: ChainSymbols.sui,
  name: "Sui",
  logo: SuiLogo,
  network: networkSui,
  nativeCurrency: { name: "Sui", symbol: "SUI", decimals: 9 },
  rpcUrls: {
    default: { http: ["https://fullnode.mainnet.sui.io"] },
  },
  blockExplorers: {
    default: {
      name: "Suiexplorer",
      url: "https://suiexplorer.com",
      hash: "https://suiexplorer.com/tx/{{addr}}",
      address: "https://suiexplorer.com/address/{{addr}}",
    },
  },
  testnet: false,
});

export const chainSuiDevnet: IChain = defineChain({
  id: ChainIds.suiDevnet,
  symbol: ChainSymbols.suiDevnet,
  name: "Sui Devnet",
  logo: SuiLogo,
  network: networkSui,
  nativeCurrency: { name: "Sui", symbol: "SUI", decimals: 9 },
  rpcUrls: {
    default: { http: ["https://fullnode.devnet.sui.io"] },
  },
  blockExplorers: {
    default: {
      name: "Suiexplorer",
      url: "https://suiexplorer.com",
      hash: "https://suiexplorer.com/tx/{{addr}}",
      address: "https://suiexplorer.com/address/{{addr}}",
    },
  },
  testnet: true,
});
